import { render, staticRenderFns } from "./GameContent.vue?vue&type=template&id=e62a7e74&scoped=true&"
import script from "./GameContent.vue?vue&type=script&lang=js&"
export * from "./GameContent.vue?vue&type=script&lang=js&"
import style0 from "./GameContent.vue?vue&type=style&index=0&id=e62a7e74&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e62a7e74",
  null
  
)

export default component.exports